import { IOperation } from './i-operation';
import { LabelingTextureData } from '@project/components/label/labeling-texture-data';
import { Connection } from '@3d-scene/model3d/connection';
import { MetaElementUsageIdentityVO, TextureAreaUsageVO } from '../../vo/meta-element.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ContainerService } from '@3d-scene/model3d/container.service';

export class UndoConnectionLabelOperation implements IOperation {
  private _metaElementUsage: TextureAreaUsageVO;
  private _oldData: LabelingTextureData;
  private _newData: LabelingTextureData;

  constructor(connectionCube: Connection, oldData: LabelingTextureData, private containerService: ContainerService) {
    this._metaElementUsage = connectionCube.metaElementUsage as TextureAreaUsageVO;
    this._oldData = oldData;
    this._newData = new LabelingTextureData(this._metaElementUsage);
  }

  public getQualifiedClassName(): string {
    return 'UndoConnectionLabelOperation';
  }

  public get metaUsage(): TextureAreaUsageVO {
    return this._metaElementUsage;
  }

  public getOperationDescription(): string {
    return '';
  }

  public get metaUsageIdentity(): MetaElementUsageIdentityVO {
    return this._metaElementUsage.identity;
  }

  public async performRedo(): Promise<void> {
    this.setLabelData(this._newData);
  }

  public async performUndo(): Promise<void> {
    this.setLabelData(this._oldData);
  }

  private setLabelData(data: LabelingTextureData): void {
    this._metaElementUsage.textValue = data.textValue;
    this._metaElementUsage.previousMergedUsageId = data.previousMetaUsageId;
    this._metaElementUsage.nextMergedUsageId = data.nextMetaUsageId;
  }

  public equals(operation: any): boolean {
    if (!(operation instanceof UndoConnectionLabelOperation)) {
      return false;
    }
    const articleContainer1: ArticleContainer = this.containerService.findArticleContainerInGlobal(this._metaElementUsage.identity.articleUsageId);
    const articleContainer2: ArticleContainer = this.containerService.findArticleContainerInGlobal(operation._metaElementUsage.identity.articleUsageId);
    if (
      articleContainer1 &&
      articleContainer2 &&
      articleContainer1.articleGUID === articleContainer2.articleGUID &&
      operation._metaElementUsage.identity.articleUsageId === this._metaElementUsage.identity.articleUsageId &&
      operation._metaElementUsage.identity.metaElementName === this._metaElementUsage.identity.metaElementName
    ) {
      return this._oldData.equals(operation._oldData) && this._newData.equals(operation._newData);
    }
    return false;
  }
}
